import ReactModal from 'react-modal';
import { RoleTag } from '../pages/person/RoleTag';
import General from '../utils/GeneralUtils';
import './EmailVerificationSlideout.scss';
import './MarketThemeSlideout.scss';

const MARKET_THEMES = [
  { value: 'athletics', label: 'Athletics', description: 'Sports programs, coaching, and athletic facilities.' },
  { value: 'accountability', label: 'Accountability', description: 'Assessment, testing, and performance measurement.' },
  { value: 'career readiness', label: 'Career Readiness', description: 'Career and technical education, workforce preparation.' },
  { value: 'community and family engagement', label: 'Community & Family Engagement', description: 'Parent involvement, community partnerships, and outreach.' },
  { value: 'diversity equity and inclusion', label: 'DEI', description: 'Diversity, equity, inclusion, and belonging initiatives.' },
  { value: 'early learning', label: 'Early Learning', description: 'Pre-K, kindergarten readiness, and early childhood programs.' },
  { value: 'enrollment', label: 'Enrollment', description: 'Student registration, admissions, and enrollment management.' },
  { value: 'gifted education', label: 'Gifted Education', description: 'Programs for advanced and talented learners.' },
  { value: 'governance', label: 'Governance', description: 'School board, policy, and administrative oversight.' },
  { value: 'facilities', label: 'Facilities', description: 'Building management, maintenance, and construction.' },
  { value: 'finance', label: 'Finance', description: 'Budgeting, accounting, and financial management.' },
  { value: 'fine arts', label: 'Fine Arts', description: 'Music, visual arts, theater, and creative programs.' },
  { value: 'human resources', label: 'Human Resources', description: 'Staffing, benefits, and employee management.' },
  { value: 'literacy', label: 'Literacy', description: 'Reading, writing, and language arts instruction.' },
  { value: 'mathematics', label: 'Mathematics', description: 'Math curriculum and instruction.' },
  { value: 'multilingual learner', label: 'Multilingual Learner', description: 'ESL, bilingual education, and language acquisition.' },
  { value: 'professional development', label: 'Professional Development', description: 'Teacher training, coaching, and continuing education.' },
  { value: 'public relations', label: 'Public Relations', description: 'Communications, marketing, and media relations.' },
  { value: 'school operations', label: 'School Operations', description: 'Day-to-day school management and logistics.' },
  { value: 'science', label: 'Science', description: 'Science curriculum and laboratory instruction.' },
  { value: 'social emotional learning', label: 'SEL', description: 'Social-emotional skills, mental health, and character education.' },
  { value: 'special education', label: 'Special Education', description: 'Services for students with disabilities and IEPs.' },
  { value: 'stem', label: 'STEM', description: 'Science, technology, engineering, and math integration.' },
  { value: 'student health services', label: 'Student Health Services', description: 'School nursing, health screenings, and medical support.' },
  { value: 'wellness', label: 'Wellness', description: 'Physical and mental health programs for students and staff.' },
  { value: 'technology', label: 'Technology', description: 'IT infrastructure, devices, and digital tools.' },
  { value: 'instructional technology', label: 'Instructional Technology', description: 'EdTech, digital learning platforms, and classroom technology.' },
  { value: 'agriculture', label: 'Agriculture', description: 'Agricultural education, plant and animal science, natural resources, and FFA.' },
  { value: 'business marketing and finance', label: 'Business, Marketing & Finance', description: 'Business, marketing, finance, and accounting education.' },
  { value: 'hospitality tourism and management', label: 'Hospitality, Tourism & Management', description: 'Hospitality, culinary arts, family and consumer sciences, and tourism.' },
];

interface MarketThemeSlideoutProps {
  isOpen: boolean;
  onClose: () => void;
}

export function MarketThemeSlideout({ isOpen, onClose }: MarketThemeSlideoutProps) {
  return (
    <ReactModal
      isOpen={isOpen}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      onRequestClose={onClose}
      style={General.getSliderDefaults({ width: 'min(90vw, 500px)' })}
      parentSelector={General.getModalRoot}
    >
      <div className="email-verification-slideout">
        <div className="header">
          <h3>Market Theme</h3>
        </div>

        <div className="section intro">
          <p>Market Theme identifies the subject area or domain that a role primarily serves or influences. Use this to target contacts working in specific educational areas.</p>
        </div>

        <div className="section">
          <div className="market-theme-list">
            {MARKET_THEMES.map((theme) => (
              <div key={theme.value} className="market-theme-item">
                <RoleTag type="marketTheme" value={theme.label} size="small" />
                <p className="market-theme-item__description">{theme.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </ReactModal>
  );
}
